import PropTypes from "prop-types";
import React, { Component } from "react";
import { observable, action, toJS } from "mobx";
import { autobind } from "core-decorators";

import Icon from "../../../shared/components/Icon";

export default class SearchForm extends Component {
  /* eslint-disable react/sort-comp */
  @observable result = {
    subject: [],
    region: []
  };
  /* eslint-enable react/sort-comp */

  static propTypes = {
    onSubmit: PropTypes.func
  };

  getGroupedSortedRegions() {
    const grouped = window.APP_CONFIG.list_region.reduce((all, region) => {
      const districtName = region.districtName;
      if (!(districtName in all)) {
        all[districtName] = [];
      }
      all[districtName].push(region);
      return all;
    }, {});

    const groups = Object.keys(grouped).reduce((all, districtName) => {
      all[districtName] = [...grouped[districtName]].sort((a, b) =>
        a.title.localeCompare(b.title)
      );
      return all;
    }, {});

    return Object.keys(groups)
      .map(districtName => ({
        districtName,
        regions: groups[districtName]
      }))
      .sort((a, b) => a.districtName.localeCompare(b.districtName));
  }

  @autobind
  @action
  handleChange({ target: { name, value } }) {
    let finalValue = [];
    if (typeof value === "string" && value.startsWith("[")) {
      try {
        finalValue = JSON.parse(value);
      } catch (ex) {
        console.error(ex);
      }
    } else {
      finalValue = value === -1 ? [] : [value * 1];
    }
    this.result[name] = finalValue;
  }

  @autobind
  handleSubmit(e) {
    e.preventDefault();
    if (this.props.onSubmit) {
      this.props.onSubmit(toJS(this.result));
    }
  }

  render() {
    const sortedGroups = this.getGroupedSortedRegions();

    return (
      <form
        className="form row"
        onChange={this.handleChange}
        onSubmit={this.handleSubmit}
      >
        <div className="col-md-5 col-sm-12">
          <select
            name="subject"
            className="form-control"
            value={this.result.subject[0]}
          >
            <option value="-1">Suche nach Schulfach</option>
            {window.APP_CONFIG.list_subject.map(subject => (
              <option key={subject.id} value={subject.id}>
                {subject.title}
              </option>
            ))}
          </select>
        </div>

        <div className="col-md-4 col-sm-12">
          <select
            name="region"
            className="form-control"
            value={this.result.region[0]}
          >
            <option value="-1">In ganz Bayern</option>
            {sortedGroups.map(({ districtName, regions }) => {
              return (
                <optgroup key={districtName} label={districtName}>
                  {" "}
                  <option
                    value={`[${regions.map(region => region.id).join(",")}]`}
                  >
                    {`Gesamte Region ${districtName}`}
                  </option>
                  {regions.map(region => (
                    <option key={region.id} value={region.id}>
                      {region.title}
                    </option>
                  ))}
                </optgroup>
              );
            })}
          </select>
        </div>

        <div className="col-md-3 col-sm-12">
          <button type="submit" className="btn btn-primary col-sm-12">
            <Icon name="search" />
            <span>&nbsp;Suchen</span>
          </button>
        </div>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/frontend/base/components/SearchForm.js